import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import LoadingButton from "@mui/lab/LoadingButton";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Alert from "@mui/material/Alert";
import * as colors from "@mui/material/colors";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";
import { resetStart, clearSignUp ,verifyStart} from "../../store/auth/reducer";


const DEFAULT_VALUES = {
  email: "",
  verificationToken:"",
  newPassword: "",
  confNewPassword: "",
};

export const ResetPassword = ({ setActive , setEmail}) => {
  const dispatch = useDispatch();
  const { resetLoading, resetSuccess, resetError } = useSelector(
    (state) => state.auth
  );
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: DEFAULT_VALUES,
  });

  useEffect(() => {
    if (resetSuccess) {
   
      reset(DEFAULT_VALUES);
      toast.info("Reset successfully", {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        closeButton: false,
      });
      dispatch(clearSignUp());
      setActive();
    }
  }, [resetSuccess]);

  const onSubmit = (values) =>{
     dispatch(
        resetStart({
        ...values,
      })
    );

    // dispatch(
    //     verifyStart({
         
    //     ...values,
    //   })
    // );
  }
   
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          marginTop: "20px",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        >
          <Typography variant="h4">Reset Password</Typography>
         
        </Box>
        {resetError && <Alert severity="error">{resetError}</Alert>}
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
          }}
        >
        </Box>

        <Controller
          name="email"
          control={control}
          rules={{
            required: {
              value: true,
              message: "Email address is requried",
            },
            pattern: {
              value: /^\S+@\S+\.\S+$/,
              message: "Please enter valid emial address",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Email Address"
              variant="standard"
              sx={{
                width: "100%",
              }}
            //   helperText={errors.email && errors.email.message}
            //   error={!!errors.email}
            />
          )}
        />

        <Controller
          name="verificationToken"
          control={control}
          rules={{
            required: {
              value: true,
              message: "verificationToken is requried",
            },
            // pattern: {
            //   value: /^\+?[1-9][0-9]{7,14}$/,
            //   message: "Please enter valid phone number (e.g +251911121314)",
            // },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="verificationToken"
              variant="standard"
              sx={{
                width: "100%",
              }}
            //   helperText={errors.phoneNumber && errors.phoneNumber.message}
            //   error={!!errors.phoneNumber}
            />
          )}
        />

        <Controller
          name="newPassword"
          control={control}
          rules={{
            required: {
              value: true,
              message: "Password is requried",
            },
            pattern: {
              value:
                /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
              message:
                "Please enter strong password (at least 8 characters, must have upperase, lowercase, number and special character)",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="New Password"
              variant="standard"
              type="password"
              sx={{
                width: "100%",
              }}
            //   helperText={errors.newPassword && errors.newPassword.message}
            //   error={!!errors.newPassword}
            />
          )}
        />

<Controller
          name="confNewPassword"
          control={control}
          rules={{
            required: {
              value: true,
              message: "Confirm Password is requried",
            },
            pattern: {
              value:
                /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/,
              message:
                "Please enter strong password (at least 8 characters, must have upperase, lowercase, number and special character)",
            },
          }}
          render={({ field }) => (
            <TextField
              {...field}
              label="Confirm Password"
              variant="standard"
              type="password"
              sx={{
                width: "100%",
              }}
            //   helperText={errors.confNewPassword && errors.confNewPassword.message}
            //   error={!!errors.confNewPassword}
            />
          )}
        />

        <LoadingButton
          color="primary"
          sx={{
            backgroundColor: colors.blue[800],
            color: "#FFFFFF",
            "&:hover": {
              backgroundColor: colors.blue[800],
            },
            marginTop: "10px",
          }}
          loading={resetLoading}
          type="submit"
          
        >
          Submit
        </LoadingButton>
  
      </Box>
    </form>
  );
};
